import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { FC } from 'react';
import { Article, Question, WithContext } from 'schema-dts';

import { ContentfulCollection } from 'src/contentful/schemas/ContentfulCollection';
import { ContentfulFaqItem } from 'src/data/Contentful/ContentfulTypes';
import { JsonLD } from 'src/general/components/JsonLD/JsonLD';

interface Props {
  faqs: ContentfulCollection<ContentfulFaqItem>;
}

export const FaqJsonLD: FC<Props> = ({ faqs }) => {
  const faqQuestions = faqs.items.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: documentToPlainTextString(item.answer.json),
    },
  })) as Question[];
  const jsonLD: WithContext<Article> = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntity: [
      {
        '@type': 'FAQPage',
        mainEntity: faqQuestions,
      },
    ],
  };
  return <JsonLD jsonLD={jsonLD} />;
};
